var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.5 3.5H28.5V26.5H1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M28,4v22H2V4H28 M29,3H1v24h28V3L29,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5deff",
    d: "M5 7H25V20H5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9f6ff",
    d: "M5 14H25V19.714H5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7aadf0",
    d: "M5 20H25V23H5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9f6ff",
    d: "M11.25 11.714A2.5 2.286 0 1 0 11.25 16.286A2.5 2.286 0 1 0 11.25 11.714Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9f6ff",
    d: "M8.75 12.286A1.875 1.714 0 1 0 8.75 15.714 1.875 1.714 0 1 0 8.75 12.286zM15 12.857000000000001A2.5 2.286 0 1 0 15 17.429000000000002 2.5 2.286 0 1 0 15 12.857000000000001z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9f6ff",
    d: "M18.75 11.714A2.5 2.286 0 1 0 18.75 16.286 2.5 2.286 0 1 0 18.75 11.714zM23.75 12.857A1.25 1.143 0 1 0 23.75 15.143 1.25 1.143 0 1 0 23.75 12.857zM6.25 12.857A1.25 1.143 0 1 0 6.25 15.143 1.25 1.143 0 1 0 6.25 12.857z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9f6ff",
    d: "M21.25 12.286A1.875 1.714 0 1 0 21.25 15.714A1.875 1.714 0 1 0 21.25 12.286Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4a6d9c",
    d: "M5 20L25 20 25 19 18.75 15z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d84b8",
    d: "M20 20L5 20 5 17 11.25 14z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.f255e840f829a627afa933f91cdae16a.svg";
export { ForwardRef as ReactComponent };